import React from "react";
import { Link } from "react-router-dom";
import Hero from "../components/Hero";
import Banner from "../components/Banner";
import Services from "../components/Services";
import FeaturedProducts from "../components/FeaturedProducts";
const home = () => {
  return (
    <>
      <Hero>
        <Banner
          title="Welcome to Om Traders"
          subtitle="A trusted brand name for Quality from years"
        >
          <Link to="/products" className="btn-primary">
            our products
          </Link>
        </Banner>
      </Hero>
      <Services />
      <FeaturedProducts />
    </>
  );
};

export default home;
